/**
 * createUID
 */
export function createUID (v = '') {
  let result = '';
  const r = Math.floor(Math.random() * 8);

  [...Math.random().toString(36).slice(-8)].forEach(c => {
    result += Math.random() >= 0.5 ? c.toUpperCase() : c;
  });

  return `${result.slice(0, r)}${v}${result.slice(r)}`;
}
